module.exports = new __parcel__URL__("iphone-black-delete.6b26517f.svg").toString();